import React, {useEffect, useRef, useState} from 'react';
import { Form, Select, Divider, Checkbox } from 'antd';
import GenericDialog from '@common/GenericDialog';
import axios from "@common/axios";
import {isFormMissingValues} from "@common/utilityFunctions";

const ShareTestFamilyDialog = ({open, onClose, handleDialogOpen, testsName, testFamilyId, testFamilyName = ''}) => {
    const [initialTeacherIds, setInitialTeacherIds] = useState([]),
        [teacherIds, setTeacherIds] = useState([]),
        [shareTeachers, setShareTeachers] = useState([]),
        [shareTestFamilyForm] = Form.useForm();

    const loadedInitialTeacherIds = useRef(false);

    useEffect(() => {
        if (!loadedInitialTeacherIds.current) {
            loadedInitialTeacherIds.current = true;
            axios.get('/controlCentre/getSchoolsTeachers.action')
                .then(response => {
                    if (response.data) {
                        setShareTeachers(response.data);
                        const teacherIds = [];
                        response.data.forEach((teacher) => {
                            teacherIds.push(teacher.userId);
                        });
                        setInitialTeacherIds(teacherIds);
                    }
                }).catch((error) => {
                console.error('Error loading school\'s teachers: ', error);
            });
        }
    }, []);

    const onShareTestFamily = async () => {
        const fieldsValue = shareTestFamilyForm.getFieldsValue();

        if (isFormMissingValues(fieldsValue)) {
            shareTestFamilyForm.validateFields();
            return Promise.reject('Select at least one teacher.');
        } else {
            const params = {selectedTeachers: fieldsValue.teacherIds, testGroupId:testFamilyId};
            ShareTestFamily(params);
        }
    }

    const ShareTestFamily = (params) => {
        axios.post('/web/ui/test/shareTestGroup', params.selectedTeachers,{params:{testGroupId:params.testGroupId}}).then((response)=>{
            if (response.data && response.data.success) {
                displayToastMessage(`Test Family shared successfully`, response.data.message, 'success', 5000);
            }else{
                displayToastMessage(`Error sharing Test Family`, response.data.message, 'error', 5000);
                console.error('Error sharing Test Family');
            }
        }).catch((error)=>{
            console.error('Error sharing Test Family: ',error);
        }).finally(()=>{
            shareTestFamilyForm.resetFields();
            handleDialogOpen(false);
        })
    }

    const handleTeacherChange = value => {
        setTeacherIds(value);
    }

    const clearTeacherSelect = () => {
        shareTestFamilyForm.setFieldsValue({['teacherIds']: []});
        setTeacherIds([]);
    }

    const handleSelectAllTeacherIds = event => {
        if (event.target.checked) {
            setTeacherIds(initialTeacherIds);
            shareTestFamilyForm.setFieldsValue({['teacherIds']: initialTeacherIds});
        } else {
            clearTeacherSelect();
        }
    }

    const getDescriptionText = () => {
        return `Select a teacher(s) to share this ${testFamilyName} Test Family. Teachers with this shared Test Family can edit and assign these ${testsName.toLowerCase()} for their class.`;
    }

    return (
        <GenericDialog
            title={`Share Test Family`}
            open={open}
            dialogWidth={400}
            onClose={() => {
                handleDialogOpen(false);
                shareTestFamilyForm.resetFields();
            }}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Share',
                    callback: onShareTestFamily,
                },
            ]}
        >
            <p>{getDescriptionText()}</p>
            <Divider className={'ch-divider'} />
            <Form
                form={shareTestFamilyForm}
                className={'ch-form'}
                layout={'vertical'}
            >
                <Form.Item
                    label="Teachers"
                    name="teacherIds"
                    rules={[
                        {
                            required: true,
                            message: 'Select at least one teacher.',
                        },
                    ]}
                >
                    <Select
                        virtual={false}
                        showSearch={true}
                        popupRender={(menu) => (
                            <>
                                {menu}
                                <Divider style={{ margin: '0 0 4px 0' }} />
                                <div style={{ padding: '4px' }}>
                                    <Checkbox
                                        disabled={initialTeacherIds.length === 0}
                                        checked={initialTeacherIds.length === teacherIds.length}
                                        onChange={handleSelectAllTeacherIds}
                                    >
                                        Select all teachers
                                    </Checkbox>
                                </div>
                            </>
                        )}
                        allowClear
                        autoClearSearchValue={true}
                        onChange={handleTeacherChange}
                        mode="multiple"
                        maxTagCount="responsive"
                        filterOption={(input, option) =>
                            option.label?.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {shareTeachers?.map((teacher) => (
                            <Select.Option
                                key={teacher.userId}
                                value={teacher.userId}
                                label={`${teacher.firstName} ${teacher.lastName}`}
                            >
                                {teacher.firstName + ' ' + teacher.lastName}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default ShareTestFamilyDialog;
